import {Pipe, PipeTransform} from '@angular/core';
import moment, {isMoment, Moment} from 'moment-timezone';
import {AppConstants} from '../util/app-constants';
import {AceLoggerService} from '@app/logging/ace-logger.service';
import {AceLogger} from '@app/logging/ace-logger';

export const USER_TIMEZONE = 'user';

interface DateConfig {
  format?: string;
  timezone?: typeof USER_TIMEZONE |  string | null;
}

@Pipe({name: 'aceDate', standalone: false})
export class AceDatePipe implements PipeTransform {
  private readonly DEFAULT_FORMAT = AppConstants.DATE_PIPE_DISPLAY_FORMAT;
  private readonly logger: AceLogger;

  constructor(aceLoggerService: AceLoggerService) {
    this.logger = aceLoggerService.create(AceDatePipe.name);
  }

  transform(value: unknown, formatOrConfig?: string | DateConfig | null): unknown {
    const config: DateConfig = formatOrConfig != null
      ? typeof formatOrConfig === 'string'
        ? {format: formatOrConfig}
        : {...formatOrConfig}
      : {};
    config.format ??= this.DEFAULT_FORMAT;
    if (typeof value === 'string' || typeof value === 'number' || isMoment(value) || value instanceof Date) {
      const dateInstance: Moment = moment(value);
      if (dateInstance.isValid()) {
        const isCustomUserTimezone = config.timezone === USER_TIMEZONE;
        if (config.timezone && !isCustomUserTimezone) {
          dateInstance.tz(config.timezone);
        } else if (isCustomUserTimezone || !dateInstance.tz()) {
          // format will use the moment's timezone but there is none, use the user's timezone
          dateInstance.tz(moment.tz.guess());
        }
        return dateInstance.format(config.format);
      }
    }
    this.logger.error('Value to transform could not be parsed or is invalid', value);
    return value;
  }
}
